const constants = {
    COOKIES: {
        ACTION_COOKIE: 'lynx_has_taken_cookie_action',
        SETTINGS_COOKIE: 'lynx_cookiesettings',
    },
    EVENTS: {
        GTM_DISPATCH: 'dispatchGTMEvents',
    },
};

export default constants;



// WEBPACK FOOTER //
// ./www/wp-content/themes/lynx-hedge/assets/scripts/src/App/constants.js